import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {Dialog} from "primereact/dialog";
import axios from "axios";

import WarehouselocationListComponent from "../warehouselocation/WarehouselocationListComponent";
import WarehouselocationFormComponent from "../warehouselocation/WarehouselocationFormComponent";

const WarehouseListComponent = (props) => {

  const {t, selectedWarehouseType, view} = props;
  const history = useHistory();
  const {entity} = useParams();
  const [warehouses, setWarehouses] = useState([]);
  const [warehouseTypes, setWarehouseTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });
  const [expandedRows, setExpandedRows] = useState(null);

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      if (selectedWarehouseType) {
        query += (query ? '&' : '?') + 'search[type][operator]==&search[type][value]=' + encodeURIComponent(selectedWarehouseType);
      }
      apiCall('get', '/api/v2/warehouse' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setWarehouses(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_warehouse_write') &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if(entity === 'warehouse') {
                      history.push('/inventory/warehouse/update/' + rowData.id)
                    }
                  }}/>
        }
        {localStorage.getItem('roles').toString().includes('role_warehouse_write') &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      setLoading(true);
                      apiCall('delete', '/api/v2/warehouse/' + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres törlés!');
                          window.App.setState({rerenderWarehouseList: Math.random()})
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    }
                  }}
          />
        }
      </React.Fragment>
    );
  }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, selectedWarehouseType, window.App.state.rerenderWarehouseList])

  useEffect(() => {
    apiCall('get', '/api/v2/dictionary/warehouse-type')
      .then(response => setWarehouseTypes(response.data.data || []))
      .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response));
  }, [])

  const warehouseTypeBodyTemplate = (rowData) => {
    const type = rowData?.type?.value || rowData?.type;
    return warehouseTypes.find(option => option.key === type)?.value || type || '';
  };

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={warehouses} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 selectionMode="single"
                onRowDoubleClick={(rowData) => {
                  if (view === 'search' || window.App.urlVars().search === 'warehouse') {
                    let _params = '?';
                    Object.entries(window.App.urlVars()).forEach(([key, value]) => {
                      if (
                        key !== 'search' &&
                        key !== 'warehouse' &&
                        key !== 'warehouseId' &&
                        key !== 'warehouseName' &&
                        value !== undefined &&
                        value !== null &&
                        value !== ''
                      ) {
                        _params += key + '=' + encodeURIComponent(value) + '&';
                      }
                    });
                    _params += 'warehouseId=' + rowData.data.id;
                    _params += '&warehouseName=' + encodeURIComponent(rowData.data.name);
                    history.push(props.backlink + _params);
                  }
                }}
                 rowExpansionTemplate={(rowData) => {
                   return (
                     <>
                      <div className="expanded-section expanded-section--warehouse-location">
                        <h4 className="expanded-section__title">
                          <i className="pi pi-map-marker" />
                          {props.t('warehouseLocations')}
                        </h4>
                        <div className="expanded-section__content">
                          <WarehouselocationListComponent warehouseId={rowData.id}/>
                        </div>
                          <div className={"p-grid p-mt-1"}>
                            <div className={"p-col-12 p-lg-6 p-xl-6"}>
                            </div>
                            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                              <Button type="button" label={props.t('addWarehouseLocation')} icon="pi pi-plus"
                                      className="p-button-success p-ml-2"
                                      onClick={() => {
                                        let _params = '?'
                                        Object.entries(window.App.urlVars()).forEach(([key, value]) => {
                                          _params += key + '=' + value + '&'
                                        })
                                        _params += 'create=warehouselocation'
                                        history.push(window.location.hash.replace('#', '') + _params)
                                      }}
                              />
                              <Dialog visible={window.App.urlVars().create === 'warehouselocation' || window.App.urlVars().update === 'warehouselocation'}
                                      style={{width: '480px'}}
                                      header={props.t('warehouseLocationData')}
                                      modal
                                      onHide={() => {
                                        history.go(-1)
                                      }}>
                                <WarehouselocationFormComponent warehouseId={rowData.id}/>
                              </Dialog>
                            </div>
                         </div>
                       </div>
                     </>
                   )
                 }}
                 dataKey="id"
                 expandedRows={expandedRows}
                 onRowToggle={(e) => {
                  const rows = e.data;
                  if (!rows || Object.keys(rows).length === 0) {
                    setExpandedRows(null);
                    return;
                  }
                  const id = Object.keys(rows)[0];
                  setExpandedRows({[id]: true});
                }}
                 onRowExpand={(e) => {
                   let id = e.data.id
                   setExpandedRows({[id]: true})
                 }}      >
        <Column field="name" header={t('columnName')} bodyClassName="col-body-font-bold" sortable filter></Column>
        <Column field="type" header={t('columnType')} sortable body={warehouseTypeBodyTemplate}></Column>
        <Column field="location.name" header={t('columnLocation')} body={(rowData) => rowData?.location?.name || ''}></Column>
        <Column field="warehouse_location_required" header={t('fieldWarehouseLocationRequired')}
                body={(rowData) => t(rowData?.warehouse_location_required ? 'yes' : 'no')}></Column>

        <Column field="created_at" header={t('columnCreatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.created_at)}</>
          )
        }}></Column>
        <Column field="updated_at" header={t('columnUpdatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.updated_at)}</>
          )
        }}></Column>
        {view !== 'search' &&
          <Column
            body={actionBodyTemplate}
            className={"p-py-0 p-text-right p-text-nowrap"}
          />
        }

        {view !== 'search' &&
          <Column
            expander={(rowData) => !!rowData.warehouse_location_required}
            style={{width: '3em'}}
          />
        }
      </DataTable>
    </>
  )
}
export default withTranslation('common')(WarehouseListComponent);
